import styles from './FormsPage.module.css';
import SearchBar from '../../../components/SearchBar/SearchBar';
import Dropdown from '../../../components/Dropdown/Dropdown';

import Dynamic from '../../../components/DynamicTable/DynamicTable';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/slices/modalSlice';
import { useState } from 'react';
import PaginationTable from '../../../components/PaginationTable/PaginationTable';
import Action from '../../../components/Action/Action';
import defaultPhoto from '../../../assets/images/Dailyactivityphoto.png'; // Replace with your file icon image
import IconAndName from '../../../components/IconAndName/IconAndName';
import { FaFileAlt } from 'react-icons/fa';
import { CgAdd } from 'react-icons/cg';

const data = [
  {
    _id: '1',
    title: '-',
    date: '-',
    status: '-',
  },
  {
    _id: '2',
    title: '-',
    date: '-',
    status: '-',
  },
  {
    _id: '3',
    title: '-',
    date: '-',
    status: '-',
  },
  {
    _id: '4',
    title: '-',
    date: '-',
    status: '-',
  },
  {
    _id: '5',
    title: '-',
    date: '-',
    status: '-',
  },
  {
    _id: '6',
    title: '-',
    date: '-',
    status: '-',
  },
  {
    _id: '7',
    title: '-',
    date: '-',
    status: '-',
  },
  {
    _id: '8',
    title: '-',
    date: '-',
    status: '-',
  },
];

function FormsPage() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        title: item.title,
        date: item.date,
        status: item.status,
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    { title: 'Title', accessor: 'title' },
    { title: 'Date', accessor: 'date' },
    { title: 'Status', accessor: 'status' },
  ];

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.headerContainer}>
        <div className={styles.totalstudentcard}>
          {/* Filters & Search */}
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar placeholder="Search Files" />
            </div>
            <div className={styles.filters}>
              <Dropdown
                label="Status"
                options={['Active', 'Disabled']}
                showAllOption={false}
              />
              <IconAndName
                icon={<CgAdd size={18} />}
                title={'Submit New Form'}
                onClick={() => dispatch(openModal({ type: 'addNewForm' }))}
              />
              <IconAndName
                title={'Add Folder'}
                onClick={() => dispatch(openModal({ type: 'editDocument' }))}
              />
            </div>
          </div>

          {/* Table */}
          <div className={styles.dynamicdata}>
            <Dynamic
              headings={headingsData}
              columnData={displayData.slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
              )}
            />
          </div>

          {/* Pagination */}
          <div className={styles.paginationTable}>
            <PaginationTable
              data={displayData}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
              setItemsPerPage={setItemsPerPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormsPage;
